import React, { FC } from 'react'
import { VStack, HStack, Text, Button, Badge, Divider, Spacer, Image, Box } from '@chakra-ui/react'
import { AvailableIntegration } from '../types'
import { analyticsAction } from '../../../common/utils/analytics'

interface AvailableIntegrationsListProps {
  integrationProviders: AvailableIntegration[]
  onConnect: (integrationProviderId: string) => void
  connectingId?: string
}

export const AvailableIntegrationsList: FC<AvailableIntegrationsListProps> = ({
  integrationProviders,
  onConnect,
  connectingId,
}) => (
  <VStack
    spacing={0}
    align="stretch"
    bg="white"
    borderRadius="lg"
    boxShadow="md"
    divider={<Divider />}
  >
    {integrationProviders.map((provider) => (
      <HStack key={provider.id} py={5} px={[2, 4, 8]} spacing={4} align="center">
        <Box
          boxSize={8}
          bg="gray.100"
          borderRadius="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mr={2}
        >
          <Image src={provider.logo} alt={provider.name} boxSize={8} />
        </Box>
        <Box flex={1}>
          <Text fontWeight="bold" fontSize="lg">
            {provider.name}
          </Text>
          <Text color="gray.500" fontSize="sm">
            {provider.description}
          </Text>
        </Box>
        <Spacer />
        {provider.connected ? (
          <Badge colorScheme="green" px={4} py={1} borderRadius="md" fontSize="md">
            Connected
          </Badge>
        ) : (
          <Button
            colorScheme="blue"
            size="md"
            onClick={() => onConnect(provider.id)}
            isLoading={connectingId === provider.id}
            loadingText="Connecting"
            {...analyticsAction('integration_connect')}
          >
            Connect
          </Button>
        )}
      </HStack>
    ))}
  </VStack>
)
